/* PRODUCT 04 · Store
   Heirloom print sales surfaced inside the gallery. */
import React from "react";
import ProductPageLayout from "./ProductPageTemplate";

const UNS = "https://images.unsplash.com";
import { EDITORIAL_ASSETS as _ED } from "@/lib/editorialAssets";

export default function StorePage() {
  return (
    <ProductPageLayout
      chapter="04"
      label="Store"
      headline={<>Print sales as a <em>print run</em>.</>}
      descriptor="Heirloom prints, linen albums, framed portraits, gift cards. Surfaced quietly inside the same gallery your client is already loving — with worldwide fulfilment by partner labs."
      features={["PRINTS","ALBUMS","FRAMES","DIGITAL DOWNLOADS","GIFT CARDS","WORLDWIDE FULFILLMENT"]}
      primaryCta={{ label: "View the storefront \u2192", href: "/gallery/spring-editorial-2026" }}
      secondaryCta={{ label: "Pricing \u2192", href: "/marketing#pricing" }}
      previewItems={[
        { label: "MATTED PRINT · 11x14", image: _ED.editorial_detail_hands.src,  alt: _ED.editorial_detail_hands.alt },
        { label: "LINEN ALBUM",           image: _ED.editorial_fabric_motion.src, alt: _ED.editorial_fabric_motion.alt },
        { label: "FRAMED PORTRAIT",       image: _ED.editorial_bw_portrait.src,   alt: _ED.editorial_bw_portrait.alt },
      ]}
    />
  );
}
